import { withRouter } from "react-router"
import React, { useEffect, Fragment, useMemo, useState } from "react"
import { useDispatch } from "react-redux"
import { Card, Box, CardContent, CircularProgress } from "@material-ui/core"
import CrewMamaAppBarComponent from "../../../components/CrewmamaAppBar/index"
import { getSoloByUniqueString, getSoloCall } from "../../../actions/solos"
import { openSnackBar } from "../../../actions/snack-bar"
import PreviewHeader from "../../../components/Billing/Solos/SoloPreview/PreviewHeader/index"
import PreviewTable from "../../../components/Billing/Solos/SoloPreview/PreviewTable/index"
import { MuiThemeProvider } from "@material-ui/core/styles"
import billingTheme from "../../../themes/billing"
import NoteBox from "../../../components/Billing/Common/NoteBox/index"
import PreviewTableHeader from "../../../components/Billing/Solos/SoloPreview/PreviewTableHeader/index"
import ClientSoloRightActions from "../../../components/Billing/Client/ClientSoloRightActions/index"
import BillingPageLayout from "../../../components/Billing/Common/BillingPageLayout/index"
import calculateTotals from "../../../utils/calculateTotals"
import ExpenseTableTotal from "../../../components/Billing/Common/ExpenseTableTotal/index"
import CopyLinkButton from "../../../components/Billing/Common/CopyLinkButton/index"
import DownloadPdfButton from "../../../components/Billing/Common/DownloadPdfButton/index"
import useActiveCompanyAdesk from "../../../hooks/useActiveCompanyAdesk"
import convertAdeskToOrganization from "../../../utils/convertAdeskToOrganization"
import { adeskPhones } from "../../../utils/adeskPhones"

const EstimatePreview = props => {
  const dispatch = useDispatch()
  let id = props.match.params.id
  let unique_string = props.match.params.unique_string
  const [estimateData, setEstimateData] = useState({})
  const [loading, setLoading] = useState(false)

  const discountAmount = (estimateData && estimateData.discount) || 0
  const paidAmount = (estimateData && estimateData.full_amount) || 0

  useEffect(
    () => {
      setLoading(true)
      if (id) {
        dispatch(getSoloCall("estimate", id))
          .then(res => {
            setEstimateData({ ...res[0] } || [])
            setLoading(false)
          })
          .catch(err => {
            console.log(err)
            dispatch(openSnackBar({ message: "Error getting estimate" }))
            setLoading(false)
          })
      } else {
        dispatch(getSoloByUniqueString("estimate", unique_string))
          .then(res => {
            setEstimateData({ ...res[0] } || [])
            setLoading(false)
          })
          .catch(err => {
            console.log(err)
            dispatch(openSnackBar({ message: "Error getting estimate" }))
            setLoading(false)
          })
      }
    },
    [id]
  )

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const amounts = useMemo(
    () => {
      if (estimateData && estimateData.estimate_id) {
        return calculateTotals(estimateData.roles, paidAmount, discountAmount)
      }
    },
    [estimateData]
  )

  const isPreview = !window.location.pathname.includes(unique_string) //gives Bool
  // if true, is admin running in preview mode - only see document (no right actions)

  const checkDiscount = useMemo(
    () => {
      if (estimateData && estimateData.roles) {
        let discountArr = []
        estimateData.roles.map(x =>
          x.expenses.filter(y => {
            if (y.discount && y.discount > 0) {
              discountArr = [...discountArr, y]
            }
            return discountArr
          })
        )
        return discountArr.length > 0
      } else {
        return false
      }
    },
    [estimateData]
  )

  const isAdesk =
    useActiveCompanyAdesk() || (estimateData && estimateData.company_id === 2)

  return (
    <Fragment>
      <MuiThemeProvider theme={billingTheme}>
        <CrewMamaAppBarComponent history={props.history} />
        {isPreview && <PreviewHeader type="Estimate" />}
        {loading ? (
          <CircularProgress />
        ) : (
          <BillingPageLayout
            hideRightSide={isPreview}
            leftContent={
              <Card
                style={
                  viewportWidth < 600
                    ? {
                        borderRadius: "20px",
                      }
                    : {
                        padding: "30px",
                        borderRadius: "20px",
                      }
                }
              >
                <CardContent>
                  <Box>
                    <PreviewTableHeader
                      type="estimate"
                      soloData={estimateData}
                    />
                    <PreviewTable
                      soloData={estimateData}
                      showDiscountColumn={checkDiscount}
                    />
                  </Box>
                  <Box
                    marginTop="40px"
                    display="flex"
                    flexDirection={viewportWidth > 600 ? "row" : "column"}
                    justifyContent={
                      viewportWidth > 600 ? "space-between" : "center"
                    }
                  >
                    <Box width={viewportWidth > 600 ? "50%" : "100%"}>
                      <NoteBox
                        noteVal={estimateData.note || ""}
                        setNoteVal={() => {}}
                        isDisabled
                        {...props}
                      />
                    </Box>
                    <Box
                      width={viewportWidth < 600 ? "100%" : "50%"}
                      marginLeft={viewportWidth < 600 ? 0 : "20%"}
                      marginRight={viewportWidth < 600 ? 0 : "20px"}
                      flexShrink={1}
                    >
                      <ExpenseTableTotal
                        data={amounts}
                        discount={discountAmount}
                        soloData={estimateData}
                        setSoloData={setEstimateData}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            }
            rightHeader={"Actions"}
            rightHeaderButtons={
              <Fragment>
                <DownloadPdfButton
                  type="estimate"
                  data={{
                    ...estimateData,
                    users: estimateData && estimateData.roles,
                    estimate_note: estimateData && estimateData.note,
                    passedAmounts: amounts,
                    company_name:
                      isAdesk && estimateData.crewmama_or_gtt
                        ? convertAdeskToOrganization(
                            estimateData.crewmama_or_gtt
                          )
                        : estimateData.company_name,
                    company_phone: isAdesk
                      ? adeskPhones(estimateData.crewmama_or_gtt)
                      : estimateData.company_phone,
                    hasLineDiscounts: checkDiscount,
                  }}
                />
                <Box width="10px" />
                <CopyLinkButton
                  docType="solo-estimate"
                  uniqueString={unique_string}
                  {...props}
                />
              </Fragment>
            }
            rightContent={
              <ClientSoloRightActions
                type="estimate"
                soloData={estimateData}
                setSoloData={setEstimateData}
                amounts={amounts}
              />
            }
          />
        )}
      </MuiThemeProvider>
    </Fragment>
  )
}

export default withRouter(EstimatePreview)
